export const POST_PROFITLOSS_LIST = 'POST_PROFITLOSS_LIST';
export const POST_PROFITLOSS_DETAIL = 'POST_PROFITLOSS_DETAIL';